import { useEffect } from 'react'
import { loadGoogleAnalytics } from '../utils/analytics'

const STORAGE_KEY = 'ng-cookie-consent'

export default function GoogleAnalytics() {
  useEffect(() => {
    if (window.localStorage.getItem(STORAGE_KEY) === 'accepted') {
      loadGoogleAnalytics()
    }

    const handleConsentChange = (event) => {
      if (event.detail === 'accepted') {
        loadGoogleAnalytics()
      }
    }

    window.addEventListener('ng-cookie-consent', handleConsentChange)
    return () => window.removeEventListener('ng-cookie-consent', handleConsentChange)
  }, [])

  return null
}